module.exports = __webpack_public_path__ + "img/ED1C24.a5604cea.svg";